<template>
  <v-container>
    <v-card outlined class="mt-2">
      <v-card-title> Оценка ЭП </v-card-title>
      <v-card-text>
        <CompareRow tag="economic" v-slot="{ value, change }">
          <CompareTableAssessment
            v-if="value"
            :value="value"
            :expandedAssIndex="expandOutIndex"
            @change="change"
            @changeExpand="changeExpand"
          />
        </CompareRow>
        <CompareRow tag="comment" v-slot="{ value, change }" class="d-flex">
          <v-textarea
            label="комментарий"
            rows="4"
            no-resize
            auto-grow
            :value="value"
            @change="change"
            hide-details
            class="my-4"
          />
        </CompareRow>
        <HelpCard
          caption="СПРАВОЧНАЯ ИНФОРМАЦИЯ – ШКАЛЫ КЭИ и АВБ"
          outlined
          border
          class="mt-4"
        >
          <KeiScore class="mb-4" />
          <AvbScore />
        </HelpCard>
        <HelpCard
          caption="СПРАВОЧНАЯ ИНФОРМАЦИЯ – баллы для оценки экономических последствий"
          outlined
          border
          class="mt-4"
        >
          <RecommendedEPScore />
        </HelpCard>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import CompareRow from '@/components/compare/CompareRow'
import { ASSESSMENT_ORGANIZATION_DEFAULT } from './const'
import HelpCard from '@/components/HelpCard'
import KeiScore from '@/components/expSummary/scales/KeiScore'
import AvbScore from '@/components/expSummary/scales/AvbScore'
import RecommendedEPScore from '../expSummary/scales/RecommendedEPScore.vue'
import CompareTableAssessment from './CompareTableAssessment.vue'

export default {
  name: 'CompareAssessment',
  components: {
    CompareRow,
    HelpCard,
    KeiScore,
    AvbScore,
    RecommendedEPScore,
    CompareTableAssessment,
  },
  computed: {
    ...mapGetters(['plp_task_id', 'compare_data']),
    maxValue() {
      if (!this.economic?.length) return 0
      return Math.max(...this.economic.map(item => item.resultScore)) || 0
    },
  },
  data() {
    return {
      ASSESSMENT_ORGANIZATION_DEFAULT,
      expandedAssessments: [0],
      expandOutIndex: null,
      economic: [],
      // assessment
      assessment: {
        loading: false,
        error: '',
        data: null,
      },
      assessmentHeaders: [
        {
          text: '№',
          value: 'id',
          width: '10px',
          sortable: false,
        },
        {
          text: 'Показание',
          value: 'condition',
          sortable: false,
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  methods: {
    ...mapMutations(['COMPARE_DATA', 'COMPARE_PART_DATA']),
    ...mapActions(['GET_PLP_REPORT']),
    changeExpand(index, isExpanded) {
      if (isExpanded) this.expandOutIndex = null
      else this.expandOutIndex = index
    },
    doChangeItem(item) {
      const idx = item.idx - 1
      this.economic[idx] = item
    },
    doBlur() {
      this.$emit('blur')
    },
  },
}
</script>
